/**
 * Deferred Analytics Loader
 * Loads non-critical analytics scripts (Clarity, Hotjar, Contentsquare, Yotpo)
 * after the page is interactive using requestIdleCallback.
 */
(function () {
  function loadAnalytics() {
    if (window.__analyticsLoaded) return;
    window.__analyticsLoaded = true;

    /* Microsoft Clarity — r3x5c2o8tf */
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'r3x5c2o8tf');

    /* Hotjar — hjid 3378749 v6 */
    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 3378749, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

    /* Yotpo Reviews + Loyalty */
    var yotpo = document.createElement('script');
    yotpo.src =
      'https://cdn-widgetsrepository.yotpo.com/v1/loader/fEpKbmiYAq2hPFnCMuHGSLnxDj6UPaRXFyoWPqbH';
    yotpo.async = true;
    document.head.appendChild(yotpo);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadAnalytics, { timeout: 4000 });
  } else {
    setTimeout(loadAnalytics, 3500);
  }
})();
